import styled, { css } from 'styled-components';

import {
    BACKGROUND_DEEP,
    BUTTON_CONTENT_BASE,
    CONTENT_BASE,
    POSITIVE_BASE,
    POSITIVE_HOVER,
    POSITIVE_PRESS,
    PRIMARY_BASE,
    PRIMARY_HOVER,
    PRIMARY_PRESS,
} from '@amzn/ring-common-style-library/lib/colors';
import {
    BODY_NORMAL_LIGHT,
    BODY_SMALL_MEDIUM,
    HEADING_NORMAL_MEDIUM
} from '@amzn/ring-common-style-library/lib/typography';

const indicatorStyle = (position: 'top' | 'bottom') => css`
    position: sticky;
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: center;
    justify-content: center;
    ${position}: 0px;
    gap: 4px;

    margin-top: ${(position === 'top' ? '-25px' : '0px')};
    padding: 4px 12px;
    border-radius: 4px;
    box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.15);
    cursor: pointer;

    ${BODY_SMALL_MEDIUM};
    text-align: center;
    
    color: ${BUTTON_CONTENT_BASE};

    /* Overlay Body Content */
    z-index: 4;
`;

const Body = styled.div<{ $loading?: boolean; }>`
    display: flex;
    flex-direction: column;

    position: relative;

    flex 1 1 auto;
    width: 100%;
    padding: 16px;

    overflow-y: auto;
    gap: 8px;

    background: ${BACKGROUND_DEEP};

    ${({ $loading }) =>
        $loading && css`
            align-items: center;
            justify-content: center;
    `}
`;

const TitleWrapper = styled.div`

`;

const Title = styled.div`
    ${HEADING_NORMAL_MEDIUM}

    color: ${CONTENT_BASE};
`;

const Subtitle = styled.div`
    ${BODY_NORMAL_LIGHT}

    color: ${CONTENT_BASE};
`;

const NewMessageIndicator = styled.div`
    ${indicatorStyle('bottom')}

    background: ${POSITIVE_BASE};
    &:hover {
        background: ${POSITIVE_HOVER};
    }

    &:active {
        background: ${POSITIVE_PRESS};
    }

`;

const LoadMessagesIndicator = styled.div`
    ${indicatorStyle('top')}

    background: ${PRIMARY_BASE};
    &:hover {
        background: ${PRIMARY_HOVER};
    }

    &:active {
        background: ${PRIMARY_PRESS};
    }
`;

const LatestMessageIndicator = styled.div`
    ${indicatorStyle('bottom')}

    background: ${PRIMARY_BASE};
    &:hover {
        background: ${PRIMARY_HOVER};
    }

    &:active {
        background: ${PRIMARY_PRESS};
    }
`;

const LoadingWrapper = styled.div`
    display: flex;
    flex: 1 1 auto;
    justify-content: center;
    align-items: center;
`;

const MoreIcon = styled.div`
    width: 16px;
    height: 16px;
    transform: rotate(180deg);
`;

const LatestIcon = styled.div`
    width: 16px;
    height: 16px;
`;

const NewIcon = styled.div`
    width: 16px;
    height: 16px;
`;

export default {
    Body,
    Title,
    TitleWrapper,
    Subtitle,
    NewMessageIndicator,
    LatestMessageIndicator,
    LatestIcon,
    LoadMessagesIndicator,
    LoadingWrapper,
    MoreIcon,
    NewIcon,
};